import React from 'react';

import { ThemeProvider } from 'styled-components';
import { ColorPalette } from 'theme/colors';
import { Theme } from 'theme/theme';

import {
  Flight,
  Departure,
  Arrival,
  DepartureArrivalTime,
  AirlineName,
  Airport,
  StopsLine,
  FlightLuggages,
  TapArea,
  RightText,
  Arrow,
} from 'components/Cards/DataCardExchangeFlights/components/SectorFlight/styles';
import { Card, Body, Price, FinalPrice, PriceContainer } from 'components/Cards/DataCardFlights/styles';
import Shimmer from 'components/Shimmer';
import withGrid from 'hocs/withGrid';

import { AirlineLogo, Footer } from './styles';

const FlightCard = () => (
  <Flight>
    <AirlineLogo />
    <Departure>
      <DepartureArrivalTime>
        <Shimmer>05:00</Shimmer>
      </DepartureArrivalTime>
      <Airport>
        <Shimmer>BOG</Shimmer>
      </Airport>
    </Departure>
    <ThemeProvider
      theme={{
        ...Theme,
        flightLine: {
          line: 'linear-gradient(90deg, rgba(250,251,251,1) -38%, rgba(184,180,180,0.5) 100%);',
          textColor: ColorPalette.HEX.DimGray,
          point: ColorPalette.HEX.DimGray,
          boxShadow: '0 0 0 2px rgba(184,180,180,0.5)',
        },
      }}
    >
      <StopsLine topText="" bottomText="" points={1} />
    </ThemeProvider>
    <Arrival>
      <DepartureArrivalTime>
        <Shimmer>06:00</Shimmer>
      </DepartureArrivalTime>
      <Airport>
        <Shimmer>MDE</Shimmer>
      </Airport>
    </Arrival>
    <TapArea>
      <RightText>
        <AirlineName>
          <Shimmer>Avianca</Shimmer>
        </AirlineName>
        <FlightLuggages>
          <Shimmer width="16px" height="18px"></Shimmer>
          <Shimmer width="16px" height="18px"></Shimmer>
          <Shimmer width="16px" height="18px"></Shimmer>
        </FlightLuggages>
      </RightText>
      <Arrow />
    </TapArea>
  </Flight>
);

interface Props {
  roundTrip: boolean;
}

const LoadingCard = ({ roundTrip }: Props) => (
  <Card>
    <Body>
      <FlightCard />
      {roundTrip && <FlightCard />}
    </Body>
    <Footer>
      <PriceContainer>
        <Price>
          <Shimmer>$99.999 COP</Shimmer>
        </Price>
        <FinalPrice>
          <Shimmer>$999.999 COP</Shimmer>
        </FinalPrice>
      </PriceContainer>

      <Shimmer>Dentro da política</Shimmer>
    </Footer>
  </Card>
);

export default withGrid(LoadingCard);
